import React from "react";

import config from "../config/config";

import AccountNavigation from "./account-navigation";
import UpsellBlock from "../components/upsell-block";
import LogoutButton from "../components/logout-button";

const AccountHelp = () => {
  return (
    <>
      <AccountNavigation />
      <div className="booking-pathway__container booking-pathway__account booking-pathway__account--help">
        <div className="booking-pathway__main-content">
          <h1 className="booking-pathway__header">Help & FAQs</h1>

          {config.OPTION_FIELDS.account?.faqs && (
            <section className="accordion">
              {config.OPTION_FIELDS.account.faqs.map((faq, index) => (
                <details key={index} className="accordion-item">
                  <summary className="accordion-item__header">
                    {faq.question}{" "}
                    <span
                      className="accordion-item__icon btn btn--mask-icon btn--square"
                      aria-hidden="true"
                    ></span>
                  </summary>
                  <div className="accordion-item__content-panel">
                    <div
                      className="accordion-item__content"
                      dangerouslySetInnerHTML={{ __html: faq.response }}
                    ></div>
                  </div>
                </details>
              ))}
            </section>
          )}
        </div>

        <div className="booking-pathway__footer">
          <LogoutButton />

          <UpsellBlock
            content={config.OPTION_FIELDS.account?.help_upsell}
            type="help-upsell"
          />
        </div>
      </div>
    </>
  );
};

export default AccountHelp;
